/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import PageUnderReview from "../../components/pageUnderReview";

function Help() {
  return (
    <Box>
      <PageUnderReview />
    </Box>
  );
}

export default Help;
